/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Payment method chosen by the user (cash or online)
 */
export enum SlotPaymentMethod {
  cash = 'cash',
  online = 'online'
}
